module.exports = __webpack_public_path__ + "img/address.6e4ee2cc.svg";